import React, { useEffect, useState } from 'react';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import { Spinner, ErrorBox, Success, DataTable, fmtDate } from '../components/ui';

export default function Users() {
  const { can } = useAuth();
  const [users, setUsers] = useState(null);
  const [orgs, setOrgs] = useState([]);
  const [roles, setRoles] = useState([]);
  const [err, setErr] = useState(null);
  const [msg, setMsg] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const blank = { username: '', email: '', fullName: '', jobTitle: '', organisationId: '', password: '', roleIds: [] };
  const [form, setForm] = useState(blank);
  const [busy, setBusy] = useState(false);
  const canManage = can('user.manage');

  const load = () => api.get('/admin/users').then(r => setUsers(r.data)).catch(setErr);
  useEffect(() => {
    load();
    api.get('/organisations').then(r => setOrgs(r.data)).catch(() => {});
    api.get('/admin/roles').then(r => setRoles(r.data)).catch(() => {});
  }, []);

  const toggleRole = id => setForm(f => ({ ...f, roleIds: f.roleIds.includes(id) ? f.roleIds.filter(x => x !== id) : [...f.roleIds, id] }));

  const submit = async e => {
    e.preventDefault(); setErr(null); setBusy(true);
    try {
      await api.post('/admin/users', { ...form, organisationId: Number(form.organisationId) });
      setMsg('User created.'); setForm(blank); setShowForm(false); load();
      setTimeout(() => setMsg(null), 2500);
    } catch (e2) { setErr(e2); } finally { setBusy(false); }
  };

  const toggleActive = async u => {
    try { await api.put(`/admin/users/${u.id}`, { isActive: !u.is_active }); load(); }
    catch (e) { setErr(e); }
  };

  if (!users) return <Spinner label="Loading users…" />;
  return <>
    <div className="phead"><h1>Users</h1>
      {canManage && <button className="primary" onClick={() => setShowForm(s => !s)}>{showForm ? 'Close' : '+ New user'}</button>}
    </div>
    <Success message={msg} /><ErrorBox error={err} />

    {showForm && canManage && <div className="panel">
      <h3>Create user</h3>
      <form onSubmit={submit}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div className="field"><label>Full name</label><input style={{ width: '100%' }} value={form.fullName} onChange={e => setForm({ ...form, fullName: e.target.value })} required /></div>
          <div className="field"><label>Job title</label><input style={{ width: '100%' }} value={form.jobTitle} onChange={e => setForm({ ...form, jobTitle: e.target.value })} /></div>
          <div className="field"><label>Username</label><input style={{ width: '100%' }} value={form.username} onChange={e => setForm({ ...form, username: e.target.value })} required /></div>
          <div className="field"><label>Email</label><input type="email" style={{ width: '100%' }} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required /></div>
          <div className="field"><label>Organisation</label>
            <select style={{ width: '100%' }} value={form.organisationId} onChange={e => setForm({ ...form, organisationId: e.target.value })} required>
              <option value="">Choose…</option>
              {orgs.map(o => <option key={o.id} value={o.id}>{o.name} ({o.type})</option>)}
            </select></div>
          <div className="field"><label>Temporary password</label><input type="text" style={{ width: '100%' }} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} required />
            <div className="muted" style={{ marginTop: 3 }}>User is prompted to change it at first sign-in.</div></div>
        </div>
        <div className="field"><label>Roles</label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10 }}>
            {roles.map(r => <label key={r.id} style={{ display: 'flex', alignItems: 'center', gap: 5, margin: 0, fontSize: 13 }}>
              <input type="checkbox" checked={form.roleIds.includes(r.id)} onChange={() => toggleRole(r.id)} /> {r.name}</label>)}
          </div>
        </div>
        <button className="primary" disabled={busy}>{busy ? 'Creating…' : 'Create user'}</button>
      </form>
    </div>}

    <div className="panel">
      <DataTable rows={users} columns={[
        { key: 'full_name', label: 'Name' },
        { key: 'username', label: 'Username' },
        { key: 'organisation_name', label: 'Organisation' },
        { key: 'roles', label: 'Roles', render: v => v || <span className="muted">none</span> },
        { key: 'last_login_at', label: 'Last login', render: fmtDate },
        { key: 'is_active', label: 'Status', render: (v, r) => <span className={`badge ${v ? 'Complete' : 'Notapplicable'}`}>{v ? 'Active' : 'Inactive'}</span> },
        ...(canManage ? [{ key: 'id', label: '', render: (v, r) => <button onClick={() => toggleActive(r)}>{r.is_active ? 'Deactivate' : 'Activate'}</button> }] : [])
      ]} />
    </div>
  </>;
}
